export const sliderItems = [
  {
    id: 1,
    img: "./assets/images/1.png",
    title: "SUMMER SALE",
    desc: " DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "./assets/images/2.png",
    title: "AUTUMN COLLECTION",
    desc: " DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "./assets/images/3.png",
    title: "POPULAR SALE",
    desc: " DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: "fbf0f4",
  },
  {
    id: 4,
    img: "./assets/images/4.png",
    title: "WINTER SALE",
    desc: "DON'T COMPROMISE QUALITY",
    bg: "f3f0fd",
  },
];

export const categories = [
  {
    id: 1,
    img: "./assets/images/8.jpg",
    title: "HIGH-HEEL SHOE",
  },
  {
    id: 2,
    img: "./assets/images/9.jpg",
    title: "ELEGANT LAPTOP",
  },
  {
    id: 3,
    img: "./assets/images/10.jpg",
    title: "MOISTURISING CREAM",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "./assets/images/5.png",
  },
  {
    id: 2,
    img: "./assets/images/6.png",
  },
  {
    id: 3,
    img: "./assets/images/7.png",
  },
  {
    id: 4,
    img: "./assets/images/13.png",
  },
  {
    id: 5,
    img: "./assets/images/14.png",
  },
  {
    id: 6,
    img: "./assets/images/25.png",
  },
  {
    id: 7,
    img: "./assets/images/16.png",
  },
  {
    id: 8,
    img: "./assets/images/23.png",
  },
  {
    id: 9,
    img: "./assets/images/17.png",
  },
  {
    id: 10,
    img: "./assets/images/24.png",
  },
];
